import { FetchContext } from 'context/FetchContext';
import { useContext } from 'react';
import { useQuery } from 'react-query';

function useCourses(data = {}) {
  const { enabled = false, configs = {} } = data;
  const fetchContext = useContext(FetchContext);
  const { privateFetch } = fetchContext;

  async function getCourses() {
    return privateFetch.get(`/v1/admin/course`, configs).then((res) => res.data);
  }

  return useQuery(['courses', { data }], getCourses, { enabled });
}

export default useCourses;
